import {
    StyledIntentTooltipContainer,
    StyledIntentTooltipContainerItem,
    StyledIntentTooltipContent,
    StyledIntentTooltipHeader,
    StyledIntentTooltipHeaderTitle,
    StyledIntentTooltipIconWrapper,
} from "./styles";
import { translate } from "app/filters/i18nFilter";
import { SWReactIcons } from "@similarweb/icons";

const IntentTooltipContent = () => {
    return (
        <StyledIntentTooltipContent>
            <StyledIntentTooltipHeader>
                <StyledIntentTooltipIconWrapper>
                    <SWReactIcons
                        size="xs"
                        iconName="light-bulb"
                    />
                </StyledIntentTooltipIconWrapper>
                <StyledIntentTooltipHeaderTitle>
                    {translate("si.intent.management.tooltip.header")}
                </StyledIntentTooltipHeaderTitle>
            </StyledIntentTooltipHeader>
            <StyledIntentTooltipContainer>
                <StyledIntentTooltipContainerItem
                    dangerouslySetInnerHTML={{
                        __html: translate("si.intent.management.tooltip.tips.item1"),
                    }}
                />
                <StyledIntentTooltipContainerItem
                    dangerouslySetInnerHTML={{
                        __html: translate("si.intent.management.tooltip.tips.item2"),
                    }}
                />
            </StyledIntentTooltipContainer>
        </StyledIntentTooltipContent>
    );
};

export default IntentTooltipContent;
